async function checkDiscount() {
    const cartItemsElement = document.querySelector('cart-items')

    if (!cartItemsElement) {
        // There's no cart elements on this page to update.
        return
    }

    let membership = null
    let discountApplied = false

    const cartRequest = await fetch('/cart.js')
    const cartData = await cartRequest.json()

    cartData.items.forEach((item) => {
        const { sku } = item
        if (sku && sku.includes('MEMBERSHIP')) {
            membership = sku
        } else if (item.discounts.length > 0) {
            item.discounts.forEach((discount) => {
                if (discount.title.includes('MEMBERSHIP')) {
                    discountApplied = true
                }
            })
        }
    })

    let discountUrl = null

    if (membership && !discountApplied) {
        discountUrl = `/checkout?discount=${membership}`
    } else if (!membership && discountApplied) {
        discountUrl = '/checkout?discount=CLEAR'
    }

    if (discountUrl) {
        setCheckoutLoading()
        fetch(discountUrl).then(() => {
            cartItemsElement.onCartUpdate()
        }).finally(() => {
            setCheckoutLoading(false)
        })
    }
}

function setCheckoutLoading(isLoading = true) {
    const checkoutButton = document.querySelector('.cart__checkout-button')
    if (checkoutButton) {
        if (isLoading) {
            checkoutButton.setAttribute('disabled', true)
        } else {
            checkoutButton.removeAttribute('disabled')
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    checkDiscount()

    // Subscribe to the cartUpdate push event for when changes are made on the cart page after load.
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        checkDiscount()
    })
})
